import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["source", "location", "select", "insertedElement", "noticeState", "notFoundMessage"]

  static values = { url: String, id: Number }

  search() {
    if(this.validatePresence()) return;
    this.load()
  }

  load() {
    const url = this.urlMount()
      fetch(url)
        .then(response => {
          if(!response.ok) {
            if(response.status === 404) {
              response.json().then(error => {
                this.notFoundMessageTarget.hidden = false
              })
            }
            throw new Error(response.message)
          }
          return response.text()
        })
        .then(html => {
          const fragment = document
            .createRange()
            .createContextualFragment(html)
          this.insertValue()
          this.locationTarget.prepend(fragment)
          this.removeNotice()
        })
        .catch(err => "")
  }

  validatePresence() {
    const invalidFields = this.sourceTargets.filter(input => input.dataset.requiredToLoad && !input.value)
    invalidFields.map(input => input.classList.add("input--error"))
    if (!!invalidFields.length ) { return true }

    const options = Array.from(this.selectTarget.options).map(v => v.value)
    if(!!options.find(value => value == this.sourceValue)) { return true }
  }

  urlMount() {
    const url = this.urlValue.concat("?")
    const queries = this.sourceTargets.map(function(input) {
      return `${input.dataset.urlQuery}=${input.value}`
    }).join("&")

    return url.concat(queries)
  }

  insertValue() {
    const option = document.createElement("option");
    option.setAttribute("value", this.sourceValue)
    option.setAttribute("selected", "selected")
    this.selectTarget.add(option)
  }

  removeNotice() {
    if(!!this.selectTarget.options.length && this.noticeStateTarget.dataset.noticeCause){
      this.noticeStateTarget.remove()
    }
  }

  removeValue() {
    const option = document.querySelector(`option[value='${this.idValue}']`)
    option.remove();
    this.insertedElementTarget.remove()
  }

  removeError() {
    this.sourceTargets.map(input => input.classList.remove("input--error"))
    this.notFoundMessageTarget.hidden = true
  }

  get sourceValue() {
    const target = this.sourceTargets.filter(input => input.dataset.sourceValue).item(0)
    return target.value
  }
}
